module.exports = __webpack_public_path__ + "img/room.be6b9f9c.svg";